import React from 'react';

export const Utilities = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M7.25 16H2.66667C2.22464 16 1.80072 15.8244 1.48816 15.5118C1.17559 15.1993 1 14.7754 1 14.3333V2.66667C1 2.22464 1.17559 1.80072 1.48816 1.48816C1.80072 1.17559 2.22464 1 2.66667 1H14.3333C14.7754 1 15.1993 1.17559 15.5118 1.48816C15.8244 1.80072 16 2.22464 16 2.66667V7.25M10.4167 14.8333L11.25 14.5M11 1V7.25M11.1667 12.5833L10.4167 12.3333M12.3333 16.5833L12.5833 15.8333M12.5 11.25L12.1667 10.4167M14.4167 11.1667L14.6667 10.4167M14.8333 16.5833L14.5 15.75M15.75 12.5L16.5833 12.1667M16.5833 14.6667L15.8333 14.4167M6 1V16M16 13.5C16 14.8807 14.8807 16 13.5 16C12.1193 16 11 14.8807 11 13.5C11 12.1193 12.1193 11 13.5 11C14.8807 11 16 12.1193 16 13.5Z'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default Utilities;
